function TermsConditions() {
  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold">Terms & Conditions</h1>
          <p className="mb-0 opacity-75">Last updated: June 2025</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container policy-content">
          <h4>1. Acceptance of Terms</h4>
          <p>By accessing and using the Garvit Education website and services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>

          <h4>2. Eligibility</h4>
          <p>Our programs are open to individuals who meet the academic eligibility criteria as specified for each course. Applicants must provide accurate and truthful information during enrollment.</p>

          <h4>3. Enrollment & Admission</h4>
          <ul>
            <li>Enrollment is subject to availability and eligibility verification.</li>
            <li>Submission of an application does not guarantee admission.</li>
            <li>Garvit Education reserves the right to accept or reject any application.</li>
            <li>Students must complete all required documentation within the specified timeline.</li>
          </ul>

          <h4>4. Course Content & Schedule</h4>
          <ul>
            <li>Course content, faculty, schedules, and delivery methods may be modified at our discretion.</li>
            <li>We reserve the right to cancel or reschedule classes due to unforeseen circumstances.</li>
            <li>Students are expected to maintain minimum attendance requirements.</li>
          </ul>

          <h4>5. Intellectual Property</h4>
          <p>All content, materials, logos, and resources provided by Garvit Education are protected by intellectual property laws. Students may not reproduce, distribute, or commercially use any materials without prior written consent.</p>

          <h4>6. Student Conduct</h4>
          <ul>
            <li>Students must maintain discipline and decorum on campus and online platforms.</li>
            <li>Any form of plagiarism, cheating, or academic dishonesty will result in disciplinary action.</li>
            <li>Harassment, discrimination, or disruptive behavior will not be tolerated.</li>
          </ul>

          <h4>7. Limitation of Liability</h4>
          <p>Garvit Education shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. We do not guarantee specific employment outcomes or career results.</p>

          <h4>8. Governing Law</h4>
          <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in the applicable jurisdiction.</p>

          <h4>9. Modifications</h4>
          <p>We reserve the right to update these Terms & Conditions at any time. Continued use of our services constitutes acceptance of the revised terms.</p>

          <h4>10. Contact Us</h4>
          <p><strong>Email:</strong> support@gencollege.in</p>
        </div>
      </section>
    </>
  );
}

export default TermsConditions;
